import {
  Text,
  Box,
  ContentBlock,
  Columns,
  Column,
  Stack,
} from 'braid-design-system';
import React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import CalculatorSvg from 'src/images/calculator.svg';
import ScreeningSvg from 'src/images/screening.svg';
import WriteSvg from 'src/images/write.svg';

import { CustomHeading } from './CustomHeading';

export const WhySeekBusiness = () => {
  const contents = [
    {
      title: 'Buyer demand',
      text: 'The SEEK Business marketplace continues to break records with more buyers visiting us than ever before.',
      image: WriteSvg,
    },
    {
      title: 'Superior matching',
      text: `We'll match your business with the right buyers, both online and in our recommended business emails sent directly to buyers.`,
      image: CalculatorSvg,
    },
    {
      title: 'Support when you need it',
      text: `We'll send you resources when you need them most, and our local team is just a phone call or email away.`,
      image: ScreeningSvg,
    },
  ];

  return (
    <ContentBlock>
      <Box paddingY="xlarge" paddingX="large" background="surface">
        <Stack space="medium">
          <Box textAlign="center">
            <CustomHeading semanticLevel="h2" mobileLevel="1" tabletLevel="2">
              Why SEEK Business?
            </CustomHeading>
          </Box>

          <Text tone="secondary" align="center">
            Sign up with SEEK Business to access exclusive seller resources, so
            when you want to sell, you&apos;re ready to sell.
          </Text>
        </Stack>

        <Box paddingY="large">
          <Columns space="xlarge" collapseBelow="tablet">
            {contents.map((c, index) => (
              <Column key={index}>
                <Box
                  display="flex"
                  height="full"
                  justifyContent="spaceBetween"
                  flexDirection="column"
                  alignItems="center"
                >
                  <Stack space="xsmall" align="center">
                    <CustomSvg svg={c.image} />
                    <Box marginTop="small">
                      <CustomHeading
                        semanticLevel="h3"
                        mobileLevel="2"
                        tabletLevel="3"
                      >
                        {c.title}
                      </CustomHeading>
                      <Box marginTop="medium">
                        <Text align="center">{c.text}</Text>
                      </Box>
                    </Box>
                  </Stack>
                </Box>
              </Column>
            ))}
          </Columns>
        </Box>
      </Box>
    </ContentBlock>
  );
};
